import Image from "next/image";

import MainPoster from "@public/images/main_poster.png";

import { FocusColumn } from "./focus-column/focus-column";
import { InfoColumn } from "./info-column/info-column";

import styles from "./poster.module.css";

export const Poster = () => (
  <div className={styles.posterWrapper}>
    <Image priority src={MainPoster} alt={"poster"} className={styles.poster} />
    <FocusColumn />
    <InfoColumn />
  </div>
);
